var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"area-expansion-chart__container"},[_c('highcharts',{ref:"hcComponent",attrs:{"options":_vm.chartOptions ? _vm.chartOptions : null}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }